import { AircraftManualStatus } from "@nova/schemas"
import { Status } from "@nova/ds-component-status"
import { AircraftComputedStatus, useAircraftMaintenanceStatus } from "./AircraftStatusQueries"

export type { AircraftComputedStatus }

export const AircraftStatusBadgeDisplay = ({
    status,
}: {
    status: AircraftComputedStatus | null
}) => {
    if (!status) return <div className="w-20 h-5 bg-gray-800 animate-pulse rounded-full" />
    if (status === "grounded")
        return (
            <Status type="error" variant="outline">
                Grounded
            </Status>
        )
    if (status === "needs_maintenance")
        return (
            <Status type="warning" variant="outline">
                Needs Maintenance
            </Status>
        )
    if (status === "maintenance_due")
        return (
            <Status type="warning" variant="outline">
                Maintenance Due
            </Status>
        )
    return (
        <Status type="positive" variant="outline">
            Good to Fly
        </Status>
    )
}

export const AircraftStatusBadge = ({
    aircraftId,
    manualStatus,
}: {
    aircraftId: string
    manualStatus: AircraftManualStatus
}) => {
    const { status } = useAircraftMaintenanceStatus(aircraftId, manualStatus)
    return <AircraftStatusBadgeDisplay status={status} />
}
